<template>
  <div class="managenment_box">
    <div class="managenment">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="bg-purple">
            <div class="price_manage">
              <div class="price_money">可提现金额</div>
              <div class="money">{{money}}元</div>
              <div class="withdraw" @click="boxWithdrawal()">
                <el-button class="withdraw_btn" type="goon">点击提现</el-button>
              </div>
            </div>
            <div class="withdrawal_box">
              <div class="rule" @click="seeRule()">-结算规则</div>
              <div class="moth">每月1号统计上个月分成金额，可随时申请提现，每月10号至15号打款，如有疑问，请联系渠道经理。</div>
            </div>
          </div>
        </el-col>
        <div class="blockGet">
          <el-date-picker
            style="width:300px;margin-left:10px"
            v-model="value1"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            @change="pickerOptions"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
          ></el-date-picker>
        </div>
        <el-col :span="18">
          <div class="tableList">提现记录列表</div>

          <div style="margin-right:20px">
            <el-table
              class="tableBox"
              :header-cell-style="{background:'#F1F6F9',color:'#606266',width: '100%'}"
              :data="tableData"
              border
            >

              <el-table-column label="代理昵称" align="center">
                <template slot-scope="scoope">
                  <span>{{scoope.row.account_number}}</span>
                </template>
              </el-table-column>

              <el-table-column label="支付宝账号" align="center">
                <template slot-scope="scoope">
                  <span>{{scoope.row.alipay_accout}}</span>
                </template>
              </el-table-column>

              <el-table-column label="提现金额" align="center">
                <template slot-scope="scoope">
                  <span>{{scoope.row.money}}</span>
                </template>
              </el-table-column>
   

              <el-table-column label="提现时间" align="center">
                <template slot-scope="scoope">
                  <span>{{scoope.row.create_date}}</span>
                </template>
              </el-table-column>

              <el-table-column label="电话" align="center">
                <template slot-scope="scoope">
                  <span>{{scoope.row.phone}}</span>
                </template>
              </el-table-column>

              <el-table-column label="支付宝名称" align="center">
                <template slot-scope="scoope">
                  <span>{{scoope.row.alipay_name}}</span>
                </template>
              </el-table-column>

              <el-table-column label="提现状态" align="center">
                <template slot-scope="scoope">
                  <el-button type="danger" plain size="mini" v-if="scoope.row.is_put == 0">未到账</el-button>
                  <el-button type="success" plain size="mini" v-else>提现成功</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>

        <el-pagination
          background
          layout="prev, pager, next"
          :total="sumPage"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </el-row>
    </div>



    <!-- 保存支付宝账号 -->
    <el-dialog title="绑定支付宝账号" :visible.sync="dialogVisible" width="30%">
      <div style="text-align: center;">
        <el-form>
          <el-form-item>
            <span class="my_span">支付宝真实姓名</span>
            <el-input v-model="withdrawal.name" placeholder="请输入支付宝姓名" style="width:250px"></el-input>
          </el-form-item>

          <el-form-item>
            <span class="my_span">身份证件号</span>
            <el-input
              v-model="withdrawal.card"
              placeholder="请输入身份证件号"
              style="width:250px"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <span class="my_span">手机号</span>
            <el-input
              v-model=" withdrawal.phone"
              placeholder="请输入手机号码"
              style="width:250px"
              maxlength="11"
              @keyup.native="inputChange"
            ></el-input>
          </el-form-item>

          <el-form-item class="getShort">
            <span class="my_span">短信验证</span>
            <el-input
              v-model="withdrawal.code"
              placeholder="请输入短信验证码"
              style="width:250px"
              maxlength="11"
              @keyup.native="inputChangeCode"
            ></el-input>
            <span v-show="show" class="getCode" @click="getCode()">获取验证码</span>
            <span v-show="!show" class="getCode">{{count}} s</span>
          </el-form-item>

          <el-form-item>
            <span class="my_span">支付宝账号</span>

            <el-input v-model="withdrawal.alipay_accout" placeholder="请输入支付宝账号" style="width:250px"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer" style="text-align: center;">
        <span>
          <el-button @click="confirmSave(1)" type="primary">保存</el-button>
          <el-button @click="cancel()">取 消</el-button>
        </span>
      </span>
    </el-dialog>

    <!-- 提现申请表 -->
    <el-dialog title="提现申请" :visible.sync="twoDialogVisible" width="30%">
      <div style="text-align: center;">
        <div class="amount">可提现金额：{{money}}元</div>
        <el-form>
          <el-form-item>
            <span class="my_span">支付宝真实姓名</span>
            <el-input
              v-model="withdrawal.name"
              placeholder="请输入支付宝姓名"
              style="width:250px"
              disabled="disabled"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <span class="my_span">身份证件号</span>
            <el-input
              v-model="withdrawal.card"
              placeholder="请输入身份证件号"
              style="width:250px"
              disabled="disabled"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <span class="my_span">手机号</span>
            <el-input
              v-model=" withdrawal.phone"
              placeholder="请输入手机号码"
              style="width:250px"
              maxlength="11"
              @keyup.native="inputChange"
              disabled="disabled"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <span class="my_span">支付宝账号</span>
            <el-input
              v-model="withdrawal.alipay_accout"
              placeholder="请输入支付宝账号"
              style="width:200px"
              disabled="disabled"
            ></el-input>
            <span class="modify" @click="modifyCode()">修改</span>
          </el-form-item>

          <el-form-item class="getShort">
            <span class="my_span">提现金额</span>
            <el-input
              v-model="withdrawal.amount"
              placeholder="请输入提现金额"
              maxlength="8"
              style="width:250px"
              @keyup.native="inputChangeAmount"
            ></el-input>
            <span class="getCode" @click="fullWithdrawal()">全部提现</span>
          </el-form-item>
        </el-form>
        <span slot="footer" class="diafooter">
          <el-button @click="confirmWithdrawal()" type="primary">提现</el-button>
          <el-button @click=" cancel()">取 消</el-button>
        </span>
      </div>
    </el-dialog>

    <!-- 修改支付宝信息 -->
    <el-dialog title="修改支付宝账号" :visible.sync="thressDialogVisible" width="30%">
      <div style="text-align: center;">
        <el-form>
          <el-form-item>
            <span class="my_span">支付宝真实姓名</span>
            <el-input v-model="withdrawal.name" placeholder="请输入支付宝姓名" style="width:250px"></el-input>
          </el-form-item>

          <el-form-item>
            <span class="my_span">身份证件号</span>
            <el-input
              v-model="withdrawal.card"
              placeholder="请输入身份证件号"
              style="width:250px"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <span class="my_span">手机号</span>
            <el-input
              v-model="numberPhone"
              placeholder="请输入手机号码"
              style="width:250px"
              maxlength="11"
              @keyup.native="inputChange"
              disabled="disabled"
            ></el-input>
          </el-form-item>

          <el-form-item class="getShort">
            <span class="my_span">短信验证</span>
            <el-input
              v-model="withdrawal.code"
              placeholder="请输入短信验证码"
              style="width:250px"
              maxlength="11"
              @keyup.native="inputChangeCode"
            ></el-input>
            <span v-show="show" class="getCode" @click="getCode()">获取验证码</span>
            <span v-show="!show" class="getCode">{{count}} s</span>
          </el-form-item>

          <el-form-item>
            <span class="my_span">支付宝账号</span>
            <el-input v-model="withdrawal.alipay_accout" placeholder="请输入支付宝账号" style="width:250px"></el-input>
          </el-form-item>
        </el-form>

        <span slot="footer" class="diafooter">
          <el-button type="primary" @click="confirmSave(2)">保存</el-button>
          <el-button @click="cancel()">取 消</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script >
import * as sysApi from "../../common/sys";
export default {
  data() {
    return {
      seeDialogVisible: false,
      value1: [new Date(), new Date()], // 时间日期 v-model
      dialogVisible: false, // 初始化弹出框
      twoDialogVisible: false,
      thressDialogVisible: false,
      tableData: [], // 数据列表
      params: {
        //  接口默认参数
        end_at: "",
        page: 1,
        start_at: "",
      },
      withdrawal: {
        name: "", //支付宝真实姓名
        card: "", //身份证号
        phone: "", //  手机号码
        code: "", //  验证码
        alipay_accout: "", // 支付宝账号
        amount: "", //   可提金额
        type: "", //
      },
      money: 0, //  可提金额
      numberPhone: "",
      show: true,
      count: null,
      timer: null,
      disabledStatus: false, //
      applyListTitle: "", //title的名称
      sumPage: 0,
    };
  },

  mounted() {
    this.initQuery();
  },
  created() {
    this.boxWithdrawal(1);
  },
  methods: {
    initQuery() {
      sysApi
        .apply_money_rude(this.params)
        .then((res) => {
          console.log(res);
          if (res.code != 1) {
            return this.$message.error(res.result);
          }
          // this.money = res.sumMoney;
          this.tableData = res.result;
          this.sumPage = res.sumPage;

          console.log(this.tableData);
        })
        .catch((err) => console.log("请求异常信息:" + err));
    },
    // 查看规则
    seeRule() {
      this.seeDialogVisible = true;
    },

    // 提现弹出框
    boxWithdrawal(type) {
      sysApi.read_alipay().then((res) => {
        console.log(res);
        if (type == 1) {
          this.money = res.result.ream_money ? res.result.ream_money : 0;
        } else {
          if (res.result == "record not found") {
            this.dialogVisible = true;
            this.withdrawal.type = "1";
          } else {
            if (res.result.alipay_accout == "") {
              this.dialogVisible = true;
              this.withdrawal.type = "1";
            } else {
              this.withdrawal.alipay_accout = res.result.alipay_accout;
              this.withdrawal.card = res.result.card;
              this.withdrawal.phone = res.result.phone;
              this.withdrawal.name = res.result.alipay_name;
              this.twoDialogVisible = true;
              this.withdrawal.type = "2";

              if (!res.result.card) {
                this.modifyCode();
              }
            }
          }
        }
      });
    },
    // 确定提现
    confirmWithdrawal() {
      if (Number(this.withdrawal.amount == 0)) {
        return this.$message.error("提现金额不能为0");
      }
      if (this.money < Number(this.withdrawal.amount)) {
        return this.$message.error("提现金额不能大于可提现金额");
      }
      let params = "money=" + Number(this.withdrawal.amount);
      sysApi.apply_money(params).then((res) => {
        if (res.code != 1) {
          return this.$message.error(res.result);
        }
        this.boxWithdrawal(1);
        this.twoDialogVisible = false;
        this.initQuery();
        return this.$message.success(res.result);
      });
    },
    // 修改支付宝信息
    confirmSave(type) {
      if (!this.verification()) {
        sysApi.input_alipay(this.withdrawal).then((res) => {
          if (res.code != 1) {
            return this.$message.error(res.result);
          }
          if (type == 1) {
            this.dialogVisible = false;
          } else {
            this.twoDialogVisible = false;
            this.thressDialogVisible = false;
            this.withdrawal.code = "";
            clearInterval(this.timer);
          }
          return this.$message.success(res.result);
        });
      }
    },
    // 修改
    modifyCode() {
      this.thressDialogVisible = true;
      let phone = this.withdrawal.phone;
      this.numberPhone = phone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
    },
    // 获取验证码
    getCode() {
      let withdrawal = "phone=" + this.withdrawal.phone;
      if (!this.withdrawal.phone) {
        return this.$message.error("请输入手机号");
      }
      if (this.withdrawal.phone.length != 11) {
        return this.$message.error("请输入11位手机号");
      }
      let phone = this.withdrawal.phone.slice(1, 2);
      if (phone == 0 || phone == 1 || phone == 2) {
        return this.$message.error("请输入正确的手机号");
      }
      sysApi.alipay_code(withdrawal).then((res) => {
        if (res.code != 1) {
          return this.$message.error(res.result);
        }
        const TIME_COUNT = 60;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      });
    },
    // 全部提现
    fullWithdrawal() {
      this.withdrawal.amount = this.money;
    },
    // 取消
    cancel() {
      this.withdrawal.code = "";
      this.thressDialogVisible = false;
      this.dialogVisible = false;
      this.twoDialogVisible = false;
      clearInterval(this.timer);
    },
    // 分页
    handleCurrentChange(val) {
      this.params.page = val;
      this.initQuery();
    },
    //  判断空值
    verification() {
      // debugger
      if (!this.withdrawal.name) {
        return this.$message.error("请输入支付宝姓名");
      }
      if (!this.withdrawal.phone) {
        return this.$message.error("请输入手机号");
      }
      if (this.withdrawal.phone.length != 11) {
        return this.$message.error("请输入11位手机号");
      }
      let phone = this.withdrawal.phone.slice(1, 2);
      if (phone == 0 || phone == 1 || phone == 2) {
        return this.$message.error("请输入正确的手机号");
      }
      if (!this.withdrawal.code) {
        return this.$message.error("请输入短信验证码");
      }

      if (!this.withdrawal.alipay_accout) {
        return this.$message.error("请输入支付宝账号");
      }
      return false;
    },
    // 事件日期方法
    pickerOptions(val) {
      this.params.start_at = val[0];
      this.params.end_at = val[1];
      this.initQuery();
    },
    inputChange() {
      this.withdrawal.phone = this.withdrawal.phone.replace(/\D/g, "");
    },
    inputChangeCode() {
      this.withdrawal.code = this.withdrawal.code.replace(/\D/g, "");
    },
    inputChangeAmount() {
      this.withdrawal.amount = this.withdrawal.amount.replace(/\D/g, "");
    },
  },
};
</script>
<style>
.el-dialog__header {
  background: #f3f3f3 !important;
}
.el-dialog__title {
  color: #606266 !important;
  text-align: center;
  width: 100%;

  display: inline-block;
}
</style>
<style scoped lang="scss">
.modify {
  color: red;

  padding-left: 20px;
  cursor: pointer;
}
.managenment_box {
  .managenment {
    .bg-purple {
      border-right: 10px solid #f3f3f3;
      //  border-bottom: 10px solid #f3f3f3;
      .price_manage {
        text-align: center;
        // padding-left: 20px;
        padding-top: 20px;
        // border-right: 10px solid #f3f3f3;

        padding-bottom: 10px;
        .price_money {
          text-align: center;
          color: #333;
          font-size: 18px;
          font-weight: bold;
          padding-bottom: 40px;
        }
        .money {
          color: #ff3149;
          font-size: 36px;
          font-weight: bold;
          padding-bottom: 30px;
        }
        .withdraw_btn {
          width: 138px;
          height: 38px;
        }
        .rule {
          color: #4c4c4c;
          font-size: 12px;
          padding-top: 20px;
          cursor: pointer;
        }
      }
      .withdrawal_box {
        border-top: 10px solid #f3f3f3;
        height: 399px;
        .rule {
          color: #4c4c4c;
          font-size: 14px;
          padding-top: 20px;
          text-align: center;
          font-weight: bold;
        }
        .withdrawal {
          padding: 20px 0 0 20px;
          font-size: 16px;
          font-weight: bold;
          color: #343434;
        }
        .block {
          padding: 40px 0px 0 45px;
        }
      }
    }
  }
  .grid-content {
    .listHeader {
      font-size: 18px;
      color: #2f2f2f;
      font-weight: bold;
      padding: 20px 0;
      text-align: center;
    }
  }
}
.el-form-item {
  margin-top: 20px !important;
}
.getShort {
  position: relative;
  .getCode {
    position: absolute;
    top: 3px;
    right: 84px;
    color: #7495b7;
    font-size: 14px;
    background: #f8fbff;
    height: 35px;
    width: 100px;
    line-height: 35px;
    border-left: 1px solid #e3e3e3;
    cursor: pointer;
  }
}
.my_span {
  width: 120px;
  display: inline-block;
  text-align: right;
  padding-right: 20px;
}
.amount {
  color: #df4444;
  font-size: 18px;
}
.tableList {
  border: 1px solid #ebeef5;
  border-bottom: 0px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  height: 49px;
  line-height: 49px;
  background: #f1f6f9;
}
.tableBox {
  margin-right: 20px;
}

.diafooter {
  display: inline-block;
  margin-top: 20px;
  text-align: center;
}
.el-dialog__footer {
  text-align: center !important;
}
.moth {
  line-height: 30px;
  font-size: 14px;
  padding: 20px 20px 0 0px;
  text-align: center;
}
.blockGet {
  margin: 20px;
  padding-left: 20px;
}
</style>
